__turbopack_context__.v({
  "address": "logoAddress-module-scss-module__0XX56G__address",
  "logo": "logoAddress-module-scss-module__0XX56G__logo",
  "logoAddress": "logoAddress-module-scss-module__0XX56G__logoAddress",
});
